import type { TestCaseOption } from "@/types_api/backend/transport/list_test_cases_transport_response"

export function groupTestCaseSelection(
  ids: string[],
  records: TestCaseOption[],
) {
  const byId = new Map(records.map((record) => [record.id, record]))
  const selectedIds = [...new Set(ids)]
  const byTestSet: Record<string, string[]> = {}
  const missingIds: string[] = []
  for (const id of selectedIds) {
    const record = byId.get(id)
    if (!record?.test_set_id) {
      missingIds.push(id)
      continue
    }
    const setCaseIds = (byTestSet[record.test_set_id] ??= [])
    setCaseIds.push(id)
  }
  return {
    selectedIds,
    testSetIds: Object.keys(byTestSet),
    byTestSet,
    missingIds,
  }
}

export function filterTestCaseOptions(
  records: TestCaseOption[],
  search: string,
) {
  const query = search.trim().toLowerCase()
  return records.filter((record) =>
    [
      record.id,
      record.description,
      record.input_str,
      record.test_set_name,
    ].some((value) => value?.toLowerCase().includes(query)),
  )
}
